export type FollowLinkTarget = '_blank' | '_self'

const isNativeAppLink = (href: string): boolean =>
  href.startsWith('mailto:') ||
  href.startsWith('tel:') ||
  href.startsWith('sms:')

/** Opens any href (mailto, tel, http(s)) reliably from menu/button handlers. */
export function followLink(
  href: string,
  target?: FollowLinkTarget
): void {
  if (isNativeAppLink(href)) {
    // Avoid `<a href>` normalization: browsers rewrite `%20` to `+` in mailto bodies.
    window.location.assign(href)
    return
  }

  const anchor = document.createElement('a')
  anchor.href = href

  if (target === '_blank') {
    anchor.target = '_blank'
    anchor.rel = 'noopener noreferrer'
  }

  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
}

export function resolveFollowLinkTarget(
  href: string,
  target?: FollowLinkTarget
): FollowLinkTarget | undefined {
  if (target) {
    return target
  }

  if (isNativeAppLink(href)) {
    return undefined
  }

  if (href.startsWith('http://') || href.startsWith('https://')) {
    return '_blank'
  }

  return '_self'
}
